import {BillingComponents, BillingLineItem, BillingsComponentsData, BillingState, VehiclesState} from "../../types";
import {monthNames, getNumberValue, formatDate} from "../../store/actions";


export function parseBillingFieldsTable(
    bill?: BillingState["bill"]
){
    let data = {
        distance: 0,
        batterySubCharges: 0,
        swaps: 0,
        swapCharges: 0,
        perSwapCost: "-",
        perKmCost:"-",
        dueDate: "",
        subTotal: 0,
        tax: 0,
        totalBill: 0,
        totalWithPanelty: 0,
        monthYear: "",
        totalBikes: 0,
        adjustment: 0,
        calcArrears: 0,
        billingItems: [] as BillingLineItem[],
    }
    if (bill) {
        console.log("billing items : ", bill.billingItems)
        let parseJsonBillingItems:BillingComponents = JSON.parse(bill.billingItems)
        console.log("parseJson : ", parseJsonBillingItems)
        data.batterySubCharges = 0
        data.distance = 0
        data.swaps = 0
        data.perSwapCost = "-"
        data.perKmCost = "-"
        data.swapCharges = 0
        if(parseJsonBillingItems.lineItems && parseJsonBillingItems.lineItems.length > 1) {
            data.batterySubCharges = parseJsonBillingItems.lineItems[1].total
            data.perKmCost = parseJsonBillingItems.lineItems[1].rate.toString() != "0"? "PKR "+ parseFloat(parseJsonBillingItems.lineItems[1].rate.toString()).toFixed(2) : "-"
            data.distance = parseJsonBillingItems.lineItems[1].quantity
        }
        if(parseJsonBillingItems.lineItems && parseJsonBillingItems.lineItems.length > 0) {
            data.swaps = parseJsonBillingItems.lineItems[0].quantity
            data.perSwapCost = parseJsonBillingItems.lineItems[0].rate.toString() != "0"? "PKR "+parseJsonBillingItems.lineItems[0].rate.toString(): "-"
            data.swapCharges = parseJsonBillingItems.lineItems[0].total
        }
     
        data.tax =  getNumberValue(bill.components?.fieldsMap || [], "tax") || 0;
        data.subTotal = getNumberValue(bill.components?.fieldsMap || [], "subTotal") || 0;
        data.totalBill = getNumberValue(bill.components?.fieldsMap || [], "totalBill") || 0;
        data.totalWithPanelty = getNumberValue(bill.components?.fieldsMap || [], "totalWithPanelty") || 0;
        data.adjustment = getNumberValue(bill.components?.fieldsMap || [], "adjustment") || 0;
        data.calcArrears = getNumberValue(bill.components?.fieldsMap || [], "calcArrears") || 0;
        data.dueDate = bill?.dueDate === ""?"--/--/----": formatDate(bill?.dueDate)
        data.monthYear = `${monthNames[bill.billingMonth-1]}, ${bill.billingYear}`
        data.totalBikes = bill.totalOperationalBikes
        data.billingItems = parseJsonBillingItems.dynamic_items

    }
    console.log("bill:",data);
    console.log("billing Components:",bill?.components);
    console.log("dynamic items:",data.billingItems);
    return data
}

export function parsePackages(list?: BillingState["packages"]) {
    if (list) {
        return list.map((p) => ({
            label: p.name,
            value: p.id,
        }));
    }

    return [];
}

export function parsePlans(list?: BillingState["plans"]) {
    if (list) {
        return list.map((p) => ({
            label: p.planCode,
            value: p.id,
        }));
    }
    return [];
}

export function getPackageCode(
    list: BillingState["packages"],
    id: string
): string {
    const pkg = list?.find((p) => p.id === id);
    return pkg?.code || "";
}

export function getPlanCode(
    list: BillingState["plans"],
    id: string
): string {
    const pkg = list?.find((p) => p.id === id);
    return pkg?.planCode || "";
}
